var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"shop-focus-img"},[_c('slider',{style:({ height: _vm.sliderHeight}),attrs:{"animation":"normal"}},_vm._l((_vm.adsItems),function(i,index){return _c('slider-item',{key:index},[_c('div',[_c('a',{attrs:{"href":i.linkUrl}},[_c('img',{attrs:{"src":i.imgUrl,"width":"1400","height":"370"}})])])])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6abfeece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopSlider.vue
// module id = gK0J
// module chunks = 1